//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { Box } from '@mui/material'

export default function ExtraWidthLimited(props: { children: any }): React.ReactElement {
  return (
    <Box data-testid="WidthLimited" sx={{ margin: 'auto', marginTop: 3, maxWidth: 1200 }}>
      {props.children}
    </Box>
  )
}
